import { defineStore } from 'pinia'
import {services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useHubStore = defineStore('hubStore', {
    state:() => ({
        current_team_group: null,
        current_hub: null,
        current_team: null,
        date_picked: null,
    }),
    actions : {
        async setTeamGroup(data) {
            this.current_team_group = data
        },
        async getTeamGroup(id) {
            try {
                const res = await axios.get(services.commission + 'team-group/' + id, {headers: getHeader()})
                this.current_team_group = res.data.data
            }catch(e){
                this.current_team_group = null
                console.log('Hub Store (getTeamGroup) failed:' + e.response.data.message)
            }
        },
        async getHub(id) {
            try {
                let queryparams = "";
                if(this.date_picked.length > 0)
                {
                    queryparams = '?start_date=' + this.date_picked[0] + '&end_date=' + this.date_picked[1];
                }
                const res = await axios.get(services.hub + 'hubs/' + id + queryparams, {headers: getHeader()})
                this.current_hub = res.data.data
            }catch(e){
                this.current_hub = null
                console.log('Hub Store (getHub) failed:' + e.response.data.message)
            }
        },
        async getHubTeams(id) {
            try {
                let queryparams = "";
                if(this.date_picked.length > 0)
                {
                    queryparams = '?start_date=' + this.date_picked[0] + '&end_date=' + this.date_picked[1];
                }

                const res = await axios.get(services.hub + 'hub_team/' + id + queryparams, {headers: getHeader()})
                this.current_team = res.data.data
            }catch(e){
                this.current_team = null
                console.log('Hub Store (getHubTeam) failed:' + e.response.data.message)
            }
        },
        async getCommsPayoutSummaryList(postData) {
            try {
                const res = await axios.post(services.hub + 'hub_comms/comms_payout_summary.show_by_hub_id', postData, { headers: getHeader() })
                return res.data.data;
            }catch(e){
                throw e
            }
            
        },
        async setDatePicked(newValue) {
            this.date_picked = newValue;
        }
    }
})